module.exports = __webpack_public_path__ + "img/sv116.9bf9caa0.svg";